import * as React from "react";
import type { SVGProps } from "react";
const SvgInstagramGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    {...props}
  >
    <g
      fill="#B5AEAB"
      clipPath="url(#instagram-grey_svg__a)"
    >
      <path d="M12 2.179c3.206 0 3.586.014 4.847.07 1.172.051 1.805.248 2.226.412a3.7 3.7 0 0 1 1.379.896c.421.422.68.82.895 1.378.164.422.36 1.06.412 2.226.057 1.266.07 1.646.07 4.847 0 3.207-.013 3.586-.07 4.847-.051 1.172-.248 1.805-.412 2.227a3.7 3.7 0 0 1-.895 1.378c-.422.422-.82.68-1.379.895-.421.164-1.059.361-2.226.413-1.266.056-1.645.07-4.847.07-3.206 0-3.586-.014-4.847-.07-1.172-.052-1.805-.249-2.226-.413a3.7 3.7 0 0 1-1.379-.895 3.7 3.7 0 0 1-.895-1.378c-.164-.422-.36-1.06-.412-2.227-.057-1.266-.07-1.645-.07-4.847 0-3.206.013-3.586.07-4.847.051-1.172.248-1.804.412-2.226.216-.558.478-.961.895-1.378a3.7 3.7 0 0 1 1.379-.896c.421-.164 1.059-.36 2.226-.412 1.261-.056 1.64-.07 4.847-.07m0-2.161c-3.258 0-3.666.014-4.945.07C5.78.144 4.903.35 4.144.646a5.86 5.86 0 0 0-2.128 1.387A5.9 5.9 0 0 0 .628 4.157C.333 4.92.127 5.793.07 7.067.014 8.353 0 8.76 0 12.018s.014 3.666.07 4.946c.057 1.275.263 2.151.558 2.91.31.793.717 1.463 1.388 2.129a5.9 5.9 0 0 0 2.123 1.383c.764.295 1.636.501 2.911.558 1.28.056 1.688.07 4.945.07s3.666-.014 4.946-.07c1.275-.057 2.151-.263 2.91-.558a5.9 5.9 0 0 0 2.124-1.383 5.9 5.9 0 0 0 1.383-2.123c.295-.765.501-1.636.558-2.911.056-1.28.07-1.688.07-4.946s-.014-3.665-.07-4.945c-.057-1.275-.263-2.152-.558-2.911a5.6 5.6 0 0 0-1.374-2.133A5.9 5.9 0 0 0 19.861.65C19.097.355 18.225.15 16.95.093 15.666.032 15.258.018 12 .018" />
      <path d="M12 5.854a6.166 6.166 0 0 0-6.164 6.164A6.166 6.166 0 0 0 12 18.182a6.166 6.166 0 0 0 6.164-6.164A6.166 6.166 0 0 0 12 5.854m0 10.162a3.999 3.999 0 1 1 .001-7.998A3.999 3.999 0 0 1 12 16.016M19.847 5.61a1.44 1.44 0 1 1-2.879 0 1.44 1.44 0 0 1 2.879 0" />
    </g>
    <defs>
      <clipPath id="instagram-grey_svg__a">
        <path
          fill="#fff"
          d="M0 .018h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInstagramGrey;
